import Monitoring from "../utils/Monitoring";
import AppWithStore from "./AppWithStore";

export default Monitoring.attachProfiler(AppWithStore);
